import { FormArray } from '@angular/forms';

export function minSelected(lowerBound: number) {
  return (control: FormArray) => {
    if (control.length < lowerBound) {
      return { notEnoughItems: true };
    }

    return null;
  };
}
